import { Link } from 'react-router-dom';

const cookieTypes = [
  {
    tag: '必須',
    title: '必須Cookie',
    desc: 'ウェブサイトの基本的な機能を提供するために必要なCookieです。お客様の設定を保存し、安全な接続を維持します。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20server%20room%20with%20rack%20cabinets%20and%20blue%20LED%20lights%2C%20clean%20organized%20layout%2C%20network%20infrastructure%2C%20dark%20ambient%20lighting%2C%20no%20people%2C%20high-end%20enterprise&width=480&height=600&seq=cookie-essential&orientation=portrait',
  },
  {
    tag: '分析',
    title: '分析Cookie',
    desc: 'ウェブサイトの利用状況を分析し、改善するために使用します。アクセス数やページビュー等の統計データを収集します。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20data%20analytics%20dashboard%20display%20with%20charts%20and%20graphs%2C%20multiple%20screens%2C%20dark%20ambient%20office%20lighting%2C%20clean%20setup%2C%20no%20people%2C%20financial%20data%20visualization&width=480&height=600&seq=cookie-analytics&orientation=portrait',
  },
  {
    tag: '機能',
    title: '機能性Cookie',
    desc: '言語設定や表示設定など、お客様の好みを記憶し、よりパーソナライズされた体験を提供します。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20UI%20design%20workspace%20with%20a%20large%20monitor%20displaying%20clean%20interface%2C%20minimalist%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20no%20people%2C%20professional%20creative%20environment&width=480&height=600&seq=cookie-functional&orientation=portrait',
  },
  {
    tag: '広告',
    title: '広告Cookie',
    desc: 'お客様の興味に関連した広告を表示するために使用します。第三者広告配信事業者により設定される場合があります。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20abstract%20photography%20of%20digital%20marketing%20concept%20with%20soft%20glowing%20lights%20and%20geometric%20patterns%2C%20warm%20golden%20and%20white%20tones%2C%20modern%20minimalist%20composition%2C%20no%20people%2C%20clean%20aesthetic&width=480&height=600&seq=cookie-advertising&orientation=portrait',
  },
];

export default function CookiePolicy() {
  return (
    <>
      {/* Hero */}
      <section className="relative bg-gradient-to-b from-primary-900 via-primary-800 to-primary-900 pt-28 md:pt-36 pb-16 md:pb-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-[1280px] mx-auto">
          <div className="inline-flex items-center gap-2 mb-8">
            <span className="text-accent-400 text-sm tracking-[0.2em] font-sans font-light">/</span>
            <span className="text-accent-400/80 text-xs md:text-sm tracking-[0.15em] font-sans font-light">Cookieポリシー</span>
          </div>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-white tracking-[0.06em]">
            クッキーと
            <br />
            プライバシー
          </h1>
          <p className="mt-5 text-sm md:text-base text-foreground-200/70 tracking-[0.06em] leading-[1.9] font-sans font-light max-w-xl">
            当ウェブサイトでは、サービス向上のためCookieを使用しています。本ポリシーでは、Cookieの利用目的および管理方法について説明します。
          </p>
        </div>
      </section>

      {/* Cookie Types Grid */}
      <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-heading font-light text-foreground-950 tracking-[0.06em]">
              Cookieの種類
            </h2>
            <p className="text-sm text-foreground-500 tracking-[0.08em] font-sans font-light">当サイトで使用するCookie</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {cookieTypes.map((c) => (
              <div key={c.tag} className="group cursor-pointer">
                <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                  <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute top-3 right-3">
                    <span className="inline-block px-3 py-1 rounded-full bg-primary-900/70 backdrop-blur-sm text-accent-400 text-[11px] md:text-xs tracking-[0.1em] font-sans font-light">{c.tag}</span>
                  </div>
                </div>
                <div className="mt-4 space-y-1">
                  <h3 className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">{c.title}</h3>
                  <p className="text-xs text-foreground-500 tracking-[0.05em] font-sans font-light leading-relaxed">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Long Text Content */}
      <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-100">
        <div className="max-w-[960px] mx-auto">
          <div className="rounded-lg bg-background-50 p-8 md:p-12 lg:p-16 space-y-10">
            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">Cookieとは</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                Cookie（クッキー）とは、ウェブサイトがユーザーのブラウザに保存する小さなテキストファイルです。Cookieにより、ウェブサイトはユーザーの設定や閲覧履歴を記憶し、より快適なブラウジング体験を提供することができます。
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">当サイトが使用するCookie</h3>
              <div className="space-y-6 text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                <div>
                  <p className="font-medium text-foreground-800 mb-1">必須Cookie（セッション管理）</p>
                  <p>当サイトの基本的な機能（セッション管理、セキュリティ対策）のために必要なCookieです。これらのCookieを無効にすると、サイトが正常に動作しない可能性があります。</p>
                </div>
                <div>
                  <p className="font-medium text-foreground-800 mb-1">分析Cookie（Google Analytics）</p>
                  <p>当サイトの利用状況を把握し、改善するためにGoogle Analyticsを使用しています。収集されるデータは匿名化されており、個人を特定することはできません。</p>
                </div>
                <div>
                  <p className="font-medium text-foreground-800 mb-1">機能性Cookie</p>
                  <p>言語設定やフォームの入力内容を記憶し、ユーザー体験を向上させるために使用します。</p>
                </div>
                <div>
                  <p className="font-medium text-foreground-800 mb-1">広告Cookie</p>
                  <p>当サイトでは、第三者の広告配信事業者による Cookie を使用して、ユーザーの興味に基づいた広告を表示する場合があります。</p>
                </div>
              </div>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">Cookieの管理方法</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                多くのブラウザでは、Cookieの設定を変更することができます。ブラウザの設定から、Cookieの受け入れを拒否したり、既存のCookieを削除したりすることが可能です。ただし、Cookieを無効にすると、当サイトの一部機能が正常に動作しなくなる場合があります。ブラウザごとの設定方法については、各ブラウザのヘルプページをご参照ください。
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">第三者によるCookie</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当サイトでは、Google Analytics等の第三者サービスにより設定されるCookieが含まれる場合があります。これらのCookieの取扱いについては、各サービス提供元のプライバシーポリシーをご確認ください。
              </p>
            </article>

            <article>
              <h3 className="text-lg md:text-xl text-foreground-950 tracking-[0.06em] font-sans font-medium mb-4">本ポリシーの変更</h3>
              <p className="text-sm md:text-base text-foreground-600 tracking-[0.05em] leading-[1.9] font-sans font-light">
                当社は、必要に応じて本Cookieポリシーを変更することがあります。変更後のポリシーは、当ウェブサイトに掲載された時点で効力を生じます。
              </p>
            </article>

            <p className="text-xs text-foreground-400 tracking-[0.06em] font-sans font-light pt-4">
              制定日：2015年4月1日<br />
              最終改定日：2026年4月1日
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
        <div className="max-w-[1280px] mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-light text-foreground-950 tracking-[0.06em]">
            Cookie設定の管理
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 tracking-[0.08em] font-sans font-light">
            同意の変更はいつでも可能です
          </p>
          <div className="mt-6">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-800 text-accent-400 text-sm md:text-base tracking-[0.08em] font-sans font-medium hover:bg-primary-700 transition-all duration-300 cursor-pointer whitespace-nowrap">
              お問合わせ
              <i className="ri-arrow-right-line text-lg" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}